<template>
  <div class="container">
    <StreamsSchedule />
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import getPageMeta from '@custom/core/utils/getPageMeta';
import StreamsSchedule from '@custom/components/StreamsSchedule.vue';

export default Vue.extend<unknown, unknown, unknown, unknown>({
  components: {
    StreamsSchedule,
  },
  head() {
    const { locale } = this.$channelConfig('settings');

    const meta = getPageMeta(locale, this.$route.path);
    return {
      title: meta.title,
      description: meta.title,
      meta: [
        {
          hid: 'og_title',
          property: 'og:title',
          content: meta.title,
        },
        {
          hid: 'og_description',
          property: 'og:description',
          content: meta.description,
        },
      ],
    };
  },
});
</script>
